import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    hideSelected: { type: Boolean, default: true },
    remote: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
    clear: { type: Boolean, default: true },
    focused: { type: Boolean, default: false },
    closed: { type: Boolean, default: false },
    remoteUrl: { type: String, default: '/entries/simple_search' },
    remoteField: { type: String, default: 'display_name' }
  };

  connect() {
    if (this.element.tomselect) return

    const isMultiple = this.element.multiple;
    const isRemote = this.remoteValue;
    const originalClasses = this.element.className;

    const plugins = {};
    if (this.clearValue) {
      plugins.clear_button = { title: 'Очистить' };
    }

    const ru = 'йцукенгшщзхъфывапролджэячсмитьбю.?'
    const en = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./&'

    const switchLayout = (text) => {
      return text.split('').map(char => {
        const isUpper = char === char.toUpperCase()
        const lowerChar = char.toLowerCase()

        let idx = en.indexOf(lowerChar)
        if (idx !== -1) {
          return isUpper ? ru[idx].toUpperCase() : ru[idx]
        }

        idx = ru.indexOf(lowerChar)
        if (idx !== -1) {
          return isUpper ? en[idx].toUpperCase() : en[idx]
        }

        return char
      }).join('')
    }

    const entryRegex = /[a-zA-Zа-яА-Я]+-\d+/;

    const config = {
      persist: false,
      copyClassesToDropdown: true,
      plugins: plugins,
      classNames: {
        wrapper: `ts-wrapper ${originalClasses}`,
        control: 'ts-control',
        dropdown: 'ts-dropdown',
        dropdown_content: 'ts-dropdown-content'
      },
      render: {
        no_results: () => '<div class="no-results">Ничего не найдено</div>',
        option: function(data, escape) {
          return `<div data-type="${escape(data.type || '')}">${escape(data[this.settings.labelField])}</div>`;
        },
        item: function(data, escape) {
          return `<div class="item" data-type="${escape(data.type || '')}">${escape(data[this.settings.labelField])}</div>`;
        }
      },
      score: function(search) {
        let cleanSearch = search.trim();
        if (cleanSearch.length > 300) {
          cleanSearch = cleanSearch.substring(0, 300);
        }
        const match = cleanSearch.match(entryRegex);

        if (match) {
          cleanSearch = match[0];
        }

        const score_original = this.getScoreFunction(cleanSearch)

        const altSearch = switchLayout(cleanSearch)
        const score_alt = this.getScoreFunction(altSearch)

        return function(item) {
          return Math.max(score_original(item), score_alt(item))
        }
      }
    };

    if (isRemote) {
      Object.assign(config, {
        valueField: 'id',
        labelField: this.remoteFieldValue,
        searchField: [this.remoteFieldValue],
        load: (query, callback) => {
          let cleanQuery = query.trim();
          if (cleanQuery.length > 300) {
            cleanQuery = cleanQuery.substring(0, 300);
          }
          const match = cleanQuery.match(entryRegex);
          if (match) {
            cleanQuery = match[0];
          }

          cleanQuery = cleanQuery.replace('-', ' ');

          const baseUrl = this.remoteUrlValue;
          const separator = baseUrl.includes("?") ? "&" : "?";
          const url = `${baseUrl}${separator}query=${encodeURIComponent(cleanQuery)}`;

          fetch(url)
            .then(response => {
              if (!response.ok) throw new Error();
              return response.json();
            })
            .then(data => callback(data.length > 0 ? data : undefined))
            .catch(() => {
              alert('Ошибка при попытке найти записи по вашему запросу');
              callback();
            });
        }
      });
    }

    if (isMultiple) {
      config.onItemAdd = () => {
        if (this.select) {
          this.select.setTextboxValue('');
          this.select.refreshOptions();
        }
      };

      config.plugins = {
        ...config.plugins,
        remove_button: { title: 'Убрать' },
        clear_button: { title: 'Очистить' }
      };

      if (!isRemote) {
        config.maxOptions = 60;
        config.closeAfterSelect = this.closedValue;
        config.hideSelected = this.hideSelectedValue;
      }
    } else {
      config.multiple = false;
      config.maxItems = 1;
      config.closeAfterSelect = true;
      config.onItemAdd = () => {
        if (this.select) this.select.blur();
      };

      if (isRemote) {
        config.plugins = {
          ...config.plugins,
          clear_button: { title: 'Очистить' }
        };
      } else {
        config.create = this.createValue;
        config.render.option_create = (data, escape) =>
          `<div class="create">Добавить <strong>${escape(data.input)}</strong>…</div>`;
      }
    }

    this.select = new TomSelect(this.element, config);

    if (this.focusedValue) {
      this.select.focus();
    }
  }

  disconnect() {
    if (document.querySelector(".is-dragging")) return

    this.cleanupPlugin();
  }

  beforeCache() {
    this.cleanupPlugin();
  }

  updateDependentSelect(event) {
    const dependentElement = document.getElementById("child-entry-select");
    if (!dependentElement) return;

    const dependentController = this.application.getControllerForElementAndIdentifier(dependentElement, "multiselect");
    if (!dependentController) return;

    const parentId = event.target.value;

    if (dependentController.select) {
      dependentController.select.clear();
      dependentController.select.clearOptions();
    }

    if (parentId) {
      const baseUrl = dependentElement.getAttribute("data-multiselect-remote-url-value") || "/entries/simple_search";
      const separator = baseUrl.includes("?") ? "&" : "?";

      dependentController.remoteUrlValue = `${baseUrl}${separator}parent_id=${parentId}`;
    } else {
      dependentController.remoteUrlValue = dependentElement.getAttribute("data-multiselect-remote-url-value");
    }
  }


  cleanupPlugin() {
    if (this.select) {
      try {
        this.select.close();
        this.select.destroy();
      } catch (e) {
        console.warn("Ошибка:", e);
      }
      this.select = null;
    }
  }
}
